import React, { MouseEvent, ReactNode } from 'react';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import Label from '@/components/form/Label/Label';
import { useFormContext } from 'react-hook-form';
import SelectField from '@/components/form/SelectField/SelectField';
import { FlexElement } from '@/features/forms/CrieSeuRoteiro/CrieSeuRoteiro.styles';
import { FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';
import { useTranslations } from 'next-intl';

export interface FormPassengerProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const FormPassenger = ({ children, ...props }: FormPassengerProps) => {
  const t = useTranslations('FormCrieSeuRoteiro');

  const {
    register,
    formState: { errors },
  } = useFormContext<FormCreateJourneyDataType>();

  return (
    <Fieldset size="lg" align="center">
      <legend>{t('Passageiros')}</legend>
      <FlexElement>
        <FieldGroup>
          <Label htmlFor="travelPaxAdtNumber">{t('Adulto')}(s)</Label>
          <SelectField
            id="travelPaxAdtNumber"
            error={errors.travelPaxAdtNumber?.message}
            helperText={`+ 12 ${t('anos')}`}
            {...register('travelPaxAdtNumber')}
          >
            {[...(Array(11).keys() as any)].splice(1).map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
            <option value="grupo">{t('Acima de 10 pessoas (Grupo)')}</option>
          </SelectField>
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="travelPaxChdNumber">{t('Criança')}</Label>
          <SelectField
            id="travelPaxChdNumber"
            error={errors.travelPaxChdNumber?.message}
            helperText={`2-12 ${t('anos')}`}
            {...register('travelPaxChdNumber')}
          >
            {[...(Array(11).keys() as any)].map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </SelectField>
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="travelPaxInfNumber">{t('Bebê')}</Label>
          <SelectField
            id="travelPaxInfNumber"
            error={errors.travelPaxInfNumber?.message}
            helperText={`0-23 ${t('meses')}`}
            {...register('travelPaxInfNumber')}
          >
            {[...(Array(11).keys() as any)].map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </SelectField>
        </FieldGroup>
      </FlexElement>
    </Fieldset>
  );
};

export default FormPassenger;
